import { render, staticRenderFns } from "./CPhoneApplication.vue?vue&type=template&id=3955db7e&scoped=true"
import script from "./CPhoneApplication.vue?vue&type=script&lang=js"
export * from "./CPhoneApplication.vue?vue&type=script&lang=js"
import style0 from "./CPhoneApplication.vue?vue&type=style&index=0&id=3955db7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3955db7e",
  null
  
)

export default component.exports